<template>
  <Catalogs
    title="Маркетинговые источники"
    create-text="Новый"
    :fetch-data="fetchData"
    :fields="fields"
    :route-create="'MarketingSourceAdd'"
    :route-edit="'MarketingSourceEdit'"
    :route-view="'MarketingSourceView'"
    :route-path="'/marketing_sources'"
    :can-edit="canEditMarketingSourceCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
   import Catalogs from "../Catalogs.vue";

export default {
  name: "MarketingSources",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  data() {
    return {
      fields: [
        {
          key: 'id',
          sortable: true,
          class: 'marketing_sources-id'
        },
        {
          key: 'name',
          label: "Название",
          sortable: true,
        },
        {
          key: 'active',
          label: "Активный",
          sortable: true,
        },
        {
          key: 'action',
          label: "Действия",
          class: 'marketing_sources-action'
        },
      ],
    }
  },
  methods: {
    async fetchData(data) {
      return await this.getMarketingSources(data);
    },
    canEditMarketingSourceCatalogs() {
      return this.hasPermission([PERM.CATALOG_SOURCE_EDIT]);
    }
  }
}
</script>


<style>
#marketing_sources th {
  vertical-align: middle;
}

#marketing_sources td {
  vertical-align: middle;
}

.marketing_sources-id {
  padding-left: 10px !important;
  width: 60px;
  text-align: center;
}

.marketing_sources-action {
  width: 80px;
  padding-right: 10px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/MarketingSources/MarketingSources.vue